package com.milta.feature.admin.presentation

sealed interface AdminPromptsIntent {
    data object Load : AdminPromptsIntent

    data class SelectTab(val key: String) : AdminPromptsIntent

    data class UpdateDraft(val key: String, val text: String) : AdminPromptsIntent

    data class TogglePreview(val key: String) : AdminPromptsIntent

    data class Save(val key: String) : AdminPromptsIntent

    data class Reset(val key: String) : AdminPromptsIntent
}
